export default ['de', 'it', 'sv', 'hu', 'hr'];
